var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";
import { forwardRef } from "react";

const SvgVerified = (_ref, ref) => {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.388 0H12.612C13.1619 0.0032997 13.606 0.45005 13.606 1V5.17533C13.6215 9.68813 11.1394 13.8393 7.15666 15.9613C7.1084 15.9869 7.0546 16.0001 7 16C6.94554 16 6.89195 15.9865 6.844 15.9607C2.86066 13.8394 0.378091 9.68824 0.393997 5.17533V1C0.393987 0.45005 0.838057 0.0032997 1.388 0ZM6.2 9.76333L10.9333 5.29667C11.1065 5.13292 11.1791 4.88923 11.1239 4.6574C11.0687 4.42557 10.8939 4.24082 10.6656 4.17274C10.4372 4.10465 10.1898 4.16359 10.0167 4.32733L5.75333 8.34533L4.632 7.212C4.46543 7.03807 4.218 6.9675 3.98474 7.02738C3.75148 7.08726 3.56865 7.26829 3.50646 7.50095C3.44427 7.73361 3.51239 7.98172 3.68466 8.15L5.26666 9.74733C5.52151 10.0059 5.93643 10.013 6.2 9.76333Z",
    fill: "#2366B1"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Verified.db847b1b0d24b554ef7f9c3a79bb60c0.svg";